export enum GetArticlesFilterReturnType {
  IncludeEvaluationResults = "INCLUDE_EVAL_RESULTS",
}
